// ============================================================
// dev-core-web/src/components/ToastStack.tsx
// Version: 1.0.0
// Purpose:
//   - рендерит тосты из uiStore (showToast ранее не отображался:
//     store/hook/компонент существовали, но стека не было)
//   - монтируется один раз в App (работает на всех страницах)
// ============================================================

import { Toast } from '@/components/Toast';
import { useUiStore } from '@/store/uiStore';

export function ToastStack(): React.ReactElement | null {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-toast flex flex-col items-center gap-2 p-4 sm:items-end sm:p-6"
      data-testid="toast-stack"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto w-full max-w-sm">
          <Toast
            variant={toast.variant}
            title={toast.title}
            {...(toast.description !== undefined
              ? { description: toast.description }
              : {})}
            durationMs={toast.ttlMs}
            onClose={() => dismiss(toast.id)}
          />
        </div>
      ))}
    </div>
  );
}

export default ToastStack;
